module.exports = __webpack_public_path__ + "img/5.c5054ba9.png";